import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/upgrade.svg'


const _hoisted_1 = { class: "flex flex-col justify-center items-center w-full p-4" }
const _hoisted_2 = { class: "w-full py-2 text-base text-center" }
const _hoisted_3 = {
  key: 0,
  class: "font-medium text-2xl"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "font-medium text-2xl",
  else: ""
}, " Payment method required ", -1)
const _hoisted_5 = { class: "flex flex-col justify-center items-center w-full mt-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mb-6"
}, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-justify" }, " You have reached the limit of collaborators available in your current plan, if you wish to continue expanding your team please upgrade your plan. ", -1)
const _hoisted_9 = { class: "flex flex-row justify-between w-full mt-8" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-justify" }, " To complete this action you need to set your default payment method. ", -1)
const _hoisted_12 = { class: "flex flex-row justify-between w-full mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.event === `upgrade`)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Upgrade your plan"))
        : _createCommentVNode("", true),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      (_ctx.event === `upgrade`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Button, {
                label: "Cancel",
                variant: "outlined",
                onOnClick: _ctx.closeModal
              }, null, 8, ["onOnClick"]),
              _createVNode(_component_Button, {
                label: "Upgrade my plan",
                variant: "contained",
                onOnClick: _ctx.upgradePlan
              }, null, 8, ["onOnClick"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.event === `payment_method`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_Button, {
                label: "Cancel",
                variant: "outlined",
                onOnClick: _ctx.closeModal
              }, null, 8, ["onOnClick"]),
              _createVNode(_component_Button, {
                label: "Add a payment method",
                variant: "contained",
                onOnClick: _ctx.addPaymentMehtod
              }, null, 8, ["onOnClick"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}